// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"659":"8153e0f3","693":"0cea4624","983":"16bb3355"}[chunkId] + ".chunk.js";
};